import { defineMessages, MessageDescriptor } from 'react-intl';

import { PointsStrategy } from '@ocx/graphql';
import { PurchaseIneligibilityReason } from '@ocx/data-offers';

export const ineligibilityMessages = defineMessages({
  'offer:points-strategy:cents:ineligibility-reason:not-enough-funds': {
    id: 'offer:points-strategy:cents:ineligibility-reason:not-enough-funds',
    defaultMessage: 'Sorry, you do not have enough funds.',
    description:
      'Message to display when user does not have enough points to purchase an offer for points strategy "Cents"',
  },
  'offer:points-strategy:points:ineligibility-reason:not-enough-funds': {
    id: 'offer:points-strategy:points:ineligibility-reason:not-enough-funds',
    defaultMessage: 'Sorry, you do not have enough points.',
    description:
      'Message to display when user does not have enough points to purchase an offer for points strategy "Points"',
  },
  'offer:ineligibility-reason:purchasable-eligibility-constraint-failed': {
    id: 'offer:ineligibility-reason:purchasable-eligibility-constraint-failed',
    defaultMessage:
      'You have another award that prevents you from receiving this award. Please see terms and conditions for more info.',
    description:
      'Message to display when user not allowed to purchase new offer before using/returning existing reward',
  },
  'offer:ineligibility-reason:unknown': {
    id: 'offer:ineligibility-reason:unknown',
    defaultMessage: 'Offer is not available.',
    description: 'Message to display when user can not purchase an offer with no reason',
  },
  'offer:ineligibility-reason:email-required:popup-title': {
    id: 'offer:ineligibility-reason:email-required:popup-title',
    defaultMessage: 'Access offer',
    description:
      'Title in confirmation popup when user tries to access an offer but profile is not completed (email required)',
  },
  'offer:ineligibility-reason:email-required:popup-description': {
    id: 'offer:ineligibility-reason:email-required:popup-description',
    defaultMessage: 'To access this offer, please complete your profile first.',
    description:
      'Description in confirmation popup when user tries to access an offer but profile is not completed (email required)',
  },
  'offer:ineligibility-reason:email-required:popup-button': {
    id: 'offer:ineligibility-reason:email-required:popup-button',
    defaultMessage: 'OK',
    description:
      'Confirm button text in confirmation popup when user tries to access an offer but profile is not completed (email required)',
  },
});

export const getIneligibilityMessageDescriptor = (
  reason: PurchaseIneligibilityReason,
  pointsStrategy: PointsStrategy,
): MessageDescriptor => {
  if (reason === 'purchasable_eligibility_constraint_failed') {
    return ineligibilityMessages['offer:ineligibility-reason:purchasable-eligibility-constraint-failed'];
  }
  if (reason === 'not_enough_points') {
    if (pointsStrategy === PointsStrategy.Cents) {
      return ineligibilityMessages['offer:points-strategy:cents:ineligibility-reason:not-enough-funds'];
    }
    if (pointsStrategy === PointsStrategy.Points) {
      return ineligibilityMessages['offer:points-strategy:points:ineligibility-reason:not-enough-funds'];
    }
  }
  return ineligibilityMessages['offer:ineligibility-reason:unknown'];
};
